<template>
  <div
    class="BulkOrderbysea"
    style="
      background: #ffffff;
      box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
      border-radius: 10px;
    "
  >
    <h4>私人地址</h4>
    <el-form
      ref="OrderQueryConditions"
      :label-position="labelPosition"
      :model="OrderQueryConditions"
      label-width="70px"
    >
      <el-form-item label="运单号">
        <el-input
          clearable
          style="width: 260px"
          v-model.trim="OrderQueryConditions.nos"
          @keyup.enter.native="onSubmit"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="发货地">
        <el-cascader
          style="width: 260px"
          clearable
          filterable
          placeholder="请输入发货地"
          v-model="thatALLtolist"
          :options="FBAfromCk"
          :props="FBAfromCkProps"
          ref="changefromFABck"
          @change="changefromFABck(thatALLtolist)"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="目的国">
        <el-cascader
          clearable
          filterable
          style="width: 260px"
          placeholder="请选择目的国"
          v-model="thatALLcklist"
          :options="FBAtoCk"
          :props="FBAtoCkProps"
          ref="changefromFABck"
          @change="changetoFABck(thatALLcklist)"
        >
        </el-cascader>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select style="width: 260px" v-model="state" placeholder="请选择">
          <el-option
            v-for="item in statusList"
            :key="item.state"
            :label="item.name"
            :value="item.state"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="委托日期"
      >
        <el-date-picker
          style="width: 260px"
          v-model="OrderQueryConditions.EntrustmentData"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>

      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button
      >
      <el-button type="primary" style="margin-left: 0px;background: white;border: 1px solid #FF4D01;color: #FF4D01;" @click="handleClear"
        >重置</el-button
      >
      </el-form-item>

    </el-form>

    <el-table
      border
      align="center"
      :data="tableData"
      max-height="580"
      tooltip-effect="dark"
      :header-cell-style="{ background: '#F3F3F3' }"
      ref="multipleTable"
      style="width: 95% !important; margin-left: 32px"
    >
      <el-table-column
        type="index"
        label="序号"
        width="60px"
        min-width="8%"
      ></el-table-column>
      <el-table-column
        prop="nos"
        label="运单号"
        min-width="10%"
      ></el-table-column>
      <el-table-column
        prop="customerOrderNos"
        label="自有单号"
        min-width="10%"
      ></el-table-column>
      <el-table-column
        prop="thirdName"
        label="尾程服务商"
        min-width="10%"
      ></el-table-column>
      <el-table-column
        prop="thirdNos"
        label="尾程服务商单号"
        min-width="10%"
      ></el-table-column>
      <el-table-column
        prop="polName"
        label="发货地"
        min-width="10%"
      ></el-table-column>
      <el-table-column
        prop="inputtime"
        label="委托时间"
        min-width="9%"
      ></el-table-column>
      <el-table-column
        prop="stateCode"
        label="订单状态"
        min-width="10%"
      >
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.stateCode == 'S'">待审核</div>
            <div v-else-if="scope.row.stateCode == 'A'">已入仓</div>
            <div v-else-if="scope.row.stateCode == 'F'">已作废</div>
            <div v-else-if="scope.row.stateCode == 'I'">待入仓</div>
            <div v-else>已出仓</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="podName"
        label="目的国"
        min-width="10%"
      ></el-table-column>
      <el-table-column
        prop="forecastInformation"
        label="预报信息"
        min-width="10%"
      ></el-table-column>
      <el-table-column prop="estimatedCost" label="预估费用" min-width="10%">
      </el-table-column>

      <el-table-column
        prop="receivingInformation"
        label="收货信息"
        min-width="10%"
      ></el-table-column>
      <el-table-column
        prop="recGoodsPostcode"
        label="邮政编码"
        min-width="10%"
      ></el-table-column>

      <el-table-column prop="actualCosts" label="实际费用" min-width="7%">
      </el-table-column>

      <!-- <el-table-column prop="job_status" label="状态" min-width="10%"></el-table-column> -->
      <el-table-column prop="operation" label="" min-width="13%">
        <template slot-scope="scope">
          <el-button type="text" @click="toPrivatDetails(scope.row)"
            >查看详情</el-button
          >
          <el-dropdown
            @command="
              (command) => {
                handleCommand(command, scope.row, scope);
              }
            "
          >
            <span style="cursor: pointer" class="el-dropdown-link">
              更多操作<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                command="PaivateOrder"
                v-if="scope.row.stateCode == 'S'"
                ><span>订单修改</span></el-dropdown-item
              >
              <el-dropdown-item
                command="PaivateCancel"
                v-if="scope.row.state == 1"
                ><span>订单取消</span></el-dropdown-item
              >
              <el-dropdown-item command="downLoadLabel"
                ><span>下载标签</span></el-dropdown-item
              >

              <el-dropdown-item command="reUpdateFile">
                <span>上传附件</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button @click="orderdetails(scope)" type="text" size="small"
                >查看详情</el-button
              > -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      style="margin:20px; float: right; "
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30,40,50]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <div style="clear: both"></div>

    <!-- 上传装箱清单 -->
    <el-dialog
      title="上传附件"
      :visible.sync="excelVisible"
      width="400px"
      :before-close="CloseDetails"
      :close-on-click-modal="false"
    >
      <div class="helper" style="margin-top: -10px">
        <!-- :show-file-list="false" -->
        <el-upload
          style="margin-top: 20px"
          :show-file-list="true"
          :on-remove="handleRemove"
          :file-list="fileList"
          :http-request="uploadSectionFile"
          class="upload-demo"
          drag
          action=""
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </div>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="success" size="mini" @click="Getdown()"
          >下载模板</el-button
        > -->
        <el-button
          style="margin-right: 95px; background: #FF4D01; color: #fff"
          size="medium"
          @click="handleCloseDetails"
          >点击此处，确认上传</el-button
        >
      </span>
      <template>
        <el-table
          v-show="errorLabel.length > 0"
          :data="errorLabel"
          size="mini"
          border
          style="width: 100%"
        >
          <el-table-column align="center" width="50" type="index" label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            width="80"
            prop="order"
            label="错误行"
          >
          </el-table-column>
          <el-table-column label="错误描述">
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.desc }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PrivateAddress",
  data() {
    return {
      FBAfromCkProps: { label: "namec", value: "id", children: false },
      FBAtoCkProps: { label: "namec", value: "id", children: false }, //children: "children"
      //表单
      OrderQueryConditions: {
        nos: "", //运单号
        polId: "", //发货地id
        podId: "", //目的国id
        EntrustmentData: [], //委托日期
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      thatALLcklist: [],
      thatALLtolist: [],
      FBAfromCk: [],
      FBAtoCk: [],
      toFBAdataprops: [],
      labelPosition: "left",
      //   订单状态
      state: "0",
      statusList: [
        {
          name: "全部",
          state: "0",
        },
        {
          name: "待入仓",
          state: "I",
        },
        {
          name: "已入仓",
          state: "A",
        },
        {
          name: "已出仓",
          state: "O",
        },
        {
          name: "待平台审核",
          state: "S",
        },
        {
          name: "已取消",
          state: "F",
        },
      ],
      excelVisible: false,
      errorLabel: [],
      fileList: [],
      fileId: "",
    };
  },
  methods: {
    //   下拉列表
    handleCommand(command, item, obj) {
      if (command == "PaivateOrder") {
        this.$router.push({
          name: "PrivateOrderChang",
          query: { id: item },
        });
      }
      if (command == "PaivateCancel") {
        this.OrderCancle(item);
      }
      if (command == "reUpdateFile") {
        this.reUpdateFilea(item);
      }
      if (command == "downLoadLabel") {
        this.downLoadLabel(item);
      }
    },
    // 去详情页面
    toPrivatDetails(row) {
      this.$router.push({
        name: "PrivateOrderDetails",
        query: { id: row.id },
      });
    },

    // 下载标签
    downLoadLabel(row) {
      this.axios
        .get(`/busFbx/downFBXOrderLabel/${row.nos}`)
        .then((res) => {
          if (res.data.code == 200) {
            let a = document.createElement("a");
            a.setAttribute("href", res.data.data);
            a.setAttribute("target", "_blank");
            a.click();
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //   查询
    onSubmit() {
      this.currentPage = 1;
      this.getTableList();
    },
    //  分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      // console.log(val);
      this.currentPage = val;
      this.getTableList();
    },
    // 取消订单
    OrderCancle(item) {
      let validator = (v) => (v ? true : false);
      this.$prompt("请输入作废原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator: validator,
        inputErrorMessage: "必填项",
      })
        .then(({ value }) => {
          this.axios
            .get(`/busFbx/invalidFbxOrder/${item.nos}/${value}`)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.info("作废成功");
                this.onSubmit(); //重新刷新获取列表
              } else {
                this.$message.info(res.data.message);
              }
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },
    // 获取列表
    getTableList() {
      if(!localStorage.getItem("Authorization")){
        return
      }
      let user = this.sessionGetUserInfo();
      if (this.OrderQueryConditions.EntrustmentData == null) {
        this.OrderQueryConditions.EntrustmentData = ["", ""];
      }
      if (this.OrderQueryConditions.EntrustmentData == null) {
        this.OrderQueryConditions.EntrustmentData = [];
      }
      let params = {
        beginDate: this.OrderQueryConditions.EntrustmentData[0] || "", //委托日期,
        curPage: this.currentPage,
        customerId: user.customerid,
        endDate: this.OrderQueryConditions.EntrustmentData[1] || "",
        nos: this.OrderQueryConditions.nos,
        pageSize: this.pageSize,
        podId: this.OrderQueryConditions.podId,
        polId: this.OrderQueryConditions.polId,
        startIndex: "",
        stateCode: "",
      };
      if (this.state) {
        if (this.state == 0) {
          params.stateCode = "";
        } else {
          params.stateCode = this.state;
        }
      }
      let that = this;
      this.axios
        .post("/busFbx/getPrivateAddressWebList", params)
        .then((res) => {
          //   console.log(res);
          if (res.data.code == 200 && res.data.data.privateAddressList.length) {
            this.tableData = res.data.data.privateAddressList;
          } else {
            this.tableData = [];
            this.$message("没有相关信息...");
          }
          that.total = Number(res.data.data.totalCounts);
        });
    },
    //获取省市区
    getProvinces() {
      let that = this;
      this.axios
        .post(`/filedata/filedataProvinces`)
        .then((res) => {
          that.FBAfromCk = res.data.datas;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //获取fba仓库
    getFBAtoCk() {
      this.axios
        .get("/api/filedata/findAllCountryExcludeCN")
        .then((res) => {
          // console.log(res);
          this.FBAtoCk = res.data.datas;
        })
        .catch((res) => {});
    },
    // 获取点击事件
    changefromFABck(list) {
      this.OrderQueryConditions.polId = list[0];
    },
    changetoFABck(list) {
      this.OrderQueryConditions.podId = list[0];
    },
    // 上传附件
    reUpdateFilea(item) {
      // console.log(item)
      this.excelVisible = true;
      this.fileId = item.nos;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList;
    },
    CloseDetails() {
      this.fileList = [];
      this.excelVisible = false;
    },
    // 上传
    handleCloseDetails() {
      let orderAttachmentDTOS = [];
      this.fileList.forEach((item) => {
        orderAttachmentDTOS.push({
          fileName: item.name,
          filePath: item.url,
          contentType: item.contentType,
          fileSize: item.fileSize,
        });
      });
      if (orderAttachmentDTOS.length <= 0) {
        this.$message({
          message: "文件未上传",
          type: "error",
        });
        return;
      }
      let params = {
        uploadRspDTOList: orderAttachmentDTOS,
        nos: this.fileId,
      };
      this.axios.post("/busFbx/addAccessory", params).then((res) => {
        if (res.data.code == 200) {
          this.fileList = [];
          this.excelVisible = false;
          this.$message({
            message: "上传成功",
            type: "success",
          });
        }else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },

    //上传
    uploadSectionFile(params) {
      let form = new FormData();
      form.append("file", params.file);
      this.axios.post("/busFbx/uploadOrderAttachment", form).then((res) => {
        // console.log(res);
        if (res.data.code == 200 && res.data.data) {
          let successData = {
            url: res.data.data.filePath,
            name: res.data.data.fileName,
            contentType: res.data.data.contentType,
            fileSize: res.data.data.fileSize,
          };
          this.fileList.push(successData);
          // console.log(this.fileList);
          this.$message({
            message: "上传成功",
            type: "success",
          });
        } else {
          // this.fileList = [];
          this.$message({
              message: res.data.message,
              type: "error",
            });
        }
      });
    },
    // 清空
    handleClear(){
      this.OrderQueryConditions = {
        EntrustmentData: ""
      }
      this.thatALLtolist = ""
      this.thatALLcklist = ""
      this.state = ""
      this.onSubmit()
    },
    // enter回车搜索
    enterSearch(){
      document.onkeydown = e => {
        if(e.keyCode == 13){
          this.onSubmit()
        }
      }
    },
  },
  created() {
    this.getTableList();
    this.getProvinces();
    this.getFBAtoCk();
    this.enterSearch();
  },
};
</script>

<style scoped>
.BulkOrderbysea {
  width: 100%;
  height: calc(100% - 30px);
  box-sizing: border-box;
  overflow: hidden;
}

.BulkOrderbysea h4 {
  width: 100%;
  height: 24px;
  padding-top: 30px;
  padding-left: 31px;
  font-size: 24px;
  font-family: "PingFang-SC-Bold";
  color: #343434;
}

.BulkOrderbysea .el-form {
  margin-top: 20px;
  margin-left: 31px;
}
.BulkOrderbysea .el-form .el-input {
  width: 68%;
  height: 38px;
  line-height: 38px;
  background: #ffffff;
  border-color: #e7e7e7;
  border-radius: 5px;
}
.BulkOrderbysea .el-form .el-input--suffix {
  width: 100%;
}

.BulkOrderbysea .el-select {
  width: 68%;
}
.BulkOrderbysea .el-date-editor--daterange.el-input,
.BulkOrderbysea .el-date-editor--daterange.el-input__inner,
.BulkOrderbysea .el-date-editor--timerange.el-input,
.BulkOrderbysea .el-date-editor--timerange.el-input__inner {
  width: 68%;
}
.BulkOrderbysea .el-form-item,
.el-form-item--small.el-form-item {
  /* width: 23%; */
  display: inline-block;
  margin-right: 20px;
}
.BulkOrderbysea .el-button--primary {
  width: 128px;
  height: 36px;
  padding: 0;
  /* background: #FF4D01; */
  border-radius: 5px;
  border: none;
}
.BulkOrderbysea .el-tabs__header {
  margin: 0px 30px 15px;
}
.BulkOrderbysea .el-tabs__nav-wrap::after {
  background: none;
}
.BulkOrderbysea .el-table td,
.el-table th {
  text-align: center;
}
.BulkOrderbysea .el-tabs__item.is-active {
  color: #343434;
}
.BulkOrderbysea .el-tabs__item {
  color: #9a9a9a;
}
.BulkOrderbysea .el-table__body-wrapper {
  height: 530px !important;
}
/* table 滚动条 */
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar {
  width: 3px;
}
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}

.el-pagination >>> .el-pagination__total {
 line-height: 36px !important;
}

/deep/ .el-form-item{
  margin-bottom: 8px;
  line-height: 28px;
}

/deep/ .el-input__inner{
  height: 34px;
}

/deep/ .el-date-editor .el-range-separator {
  line-height: 28px;
}

/deep/ .el-date-editor .el-range__icon {
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/PrivateAddrs/PrivateAddress.vue